export default __webpack_public_path__ + "static/media/rightBorder.4495f588.svg";